import {TR} from './TR';
export class TypeTableMinMax {

	public tr: TR[];

	constructor() { 
		 		this.tr = [];
 
	}
}
